<template>
  <div class="" style="margin-left: 10px;">
    <el-row style="text-align: center;margin-top: 10px;margin-bottom: 10px">
      <el-col :span="3" style="border: 1px solid transparent" />
      <el-col v-for="title of titles" :key="title" :span="3">
        <label>{{ title }}</label>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <el-checkbox v-model="markup.isMarkup1" no="markups1" label="Tier 1" />
      </el-col>
      <el-col v-for="(value, key) of markup.markups1" :key="key" :span="3">
        <el-input-number v-model="markup.markups1[key]" no="markups11" :disabled="!enable.markup1" :step="0.1" style="width: 95px" :min="-999999999.99" :max="999999999.99" />
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <el-checkbox v-model="markup.isMarkup2" no="isMarkup2" label="Tier 2" />
      </el-col>
      <el-col v-for="(value, key) of markup.markups2" :key="key" :span="3">
        <el-input-number v-model="markup.markups2[key]" no="isMarkup21" :disabled="!enable.markup2" :step="0.1" style="width: 95px" :min="-999999999.99" :max="999999999.99" />
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <el-checkbox v-model="markup.isMarkup3" no="isMarkup3" label="Tier 3" />
      </el-col>
      <el-col v-for="(value, key) of markup.markups3" :key="key" :span="3">
        <el-input-number v-model="markup.markups3[key]" no="markups31" :disabled="!enable.markup3" :step="0.1" style="width: 95px" :min="-999999999.99" :max="999999999.99" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'AirMarkup',
  data() {
    return {
      markupLocked: false,
      FEE_COUNT: 7,
      titles: ['M', 'N', '+45', '+100', '+300', '+500', '+1000'],
      enable: {
        markup1: true,
        markup2: true,
        markup3: true
      },
      markup: {
        isMarkup1: false,
        isMarkup2: false,
        isMarkup3: false,
        markups1: {
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0
        },
        markups2: {
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0
        },
        markups3: {
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0
        }
      }
    }
  },
  methods: {
    readConfig(source, isLock) {
      this.readIsMarkups(source, isLock)
      this.readMarkups(source)
    },
    isValid() {
      if (this.markup.isMarkup1) {
        if (this.markup.isMarkup2) {
          for (let i = 1; i <= this.FEE_COUNT; i++) {
            if (this.markup['markups2'][i] < this.markup['markups1'][i]) {
              this.$message.warning(this.$t('Pricing.Three_BE_One'))
              return false
            }
          }
        } else if (this.markup.isMarkup3) {
          for (let i = 1; i <= this.FEE_COUNT; i++) {
            if (this.markup['markups3'][i] < this.markup['markups1'][i]) {
              this.$message.warning(this.$t('Pricing.Two_BE_One'))
              return false
            }
          }
        }
      }
      if (this.markup.isMarkup2 && this.markup.isMarkup3) {
        for (let i = 1; i <= this.FEE_COUNT; i++) {
          if (this.markup['markups3'][i] < this.markup['markups2'][i]) {
            this.$message.warning(this.$t('Pricing.Three_BE_Two'))
            return false
          }
        }
      }
      return true
    },
    getParams() {
      const params = {
        markups_tier1: this.toArray(1),
        markups_tier2: this.toArray(2),
        markups_tier3: this.toArray(3)
      }
      return params
    },
    getMarkups() {
      const { isMarkup1, isMarkup2, isMarkup3 } = this.markup
      const value = {
        isMarkup1: isMarkup1,
        isMarkup2: isMarkup2,
        isMarkup3: isMarkup3
      }
      const markups1 = this.toArray(1)
      const markups2 = this.toArray(2)
      const markups3 = this.toArray(3)
      if (isMarkup1 && markups1.length !== 0) {
        value['markups1'] = markups1
      }
      if (isMarkup2 && markups2.length !== 0) {
        value['markups2'] = markups2
      }
      if (isMarkup3 && markups3.length !== 0) {
        value['markups3'] = markups3
      }
      return value
    },
    toArray(level) {
      const result = []
      if (this.markup['isMarkup' + level]) {
        for (let i = 1; i <= this.FEE_COUNT; i++) {
          result.push(this.markup['markups' + level][i])
        }
      }
      return result
    },
    readIsMarkups(source, isLock) {
      this.setBooleanMarkup(source, isLock)
    },
    setBooleanMarkup(source, isLock) {
      for (let level = 1; level < 4; level++) {
        const isField = 'isMarkup' + level
        const markupField = 'markup' + level
        if (source.hasOwnProperty(isField)) {
          this.markup[isField] = source[isField]
        }
        if (source.hasOwnProperty('markups' + level)) {
          this.enable[markupField] = !isLock
        }
      }
    },
    readMarkups(source) {
      for (let level = 1; level < 4; level++) {
        if (this.markup['isMarkup' + level]) {
          if (source.hasOwnProperty('markups' + level)) {
            const markups = source['markups' + level]
            for (let i = 1; i <= this.FEE_COUNT; i++) {
              this.markup['markups' + level][i] = markups[i - 1]
            }
            continue
          }
          for (let i = 1; i <= this.FEE_COUNT; i++) {
            this.markup['markups' + level][i] = 0
          }
        }
      }
    },
    reset() {
      for (const markup in this.markup) {
        const type = typeof this.markup[markup]
        if (type === 'boolean') {
          this.markup[markup] = false
        }
        if (type === 'object') {
          for (const item in this.markup[markup]) {
            this.markup[markup][item] = 0
          }
        }
      }
      this.enable.markup1 = true
      this.enable.markup2 = true
      this.enable.markup3 = true
    }
  }
}
</script>

<style scoped>

</style>
